import { MessageCircle } from "lucide-react";

const WhatsAppFab = () => {
  const phoneNumber = "390883411359";
  const message = "Salve, vorrei informazioni sui vostri servizi.";
  
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-fab"
      aria-label="Contattaci su WhatsApp"
      data-testid="whatsapp-fab"
    >
      <MessageCircle className="w-7 h-7" strokeWidth={2} />
    </a>
  );
};

export default WhatsAppFab;
